import { useTheme } from 'styled-components';
import { Link } from '../../../../bookings/forms/form-group.styles';
import { COLLECTION_NOTICE_URL, PRIVACY_POLICY_URL, TERMS_URL } from '../../../../bookings/urls';
import {
  TrackedElementAction,
  TrackedElementId,
  TrackingDataCta,
  TrackingDataEvent,
} from '../../../AnalyticsContext/LinkTracking';
import { renderLinkTrackingAttributes } from '../../../AnalyticsContext/renderLinkTrackingAttributes';
import { Button } from '../../Button/Button';
import { StandardModal } from '../../StandardModal/StandardModal';
import {
  CancelButton,
  LanguagePickerModal as StyledModal,
  ModalParagraph,
  ModalTitle,
} from './styles';

export interface ConfirmLanguageSelectionModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmLanguageSelectionModal = ({
  isOpen,
  onConfirm,
  onCancel,
}: ConfirmLanguageSelectionModalProps) => {
  const theme = useTheme().whiteLabelProps;

  return (
    <StandardModal isOpen={isOpen} onRequestClose={onCancel}>
      <StyledModal>
        <ModalTitle>Set preferred language?</ModalTitle>
        <ModalParagraph>
          These language options are intended to help Australians whose preferred written language
          is not English.
        </ModalParagraph>
        <ModalParagraph>
          Please note your appointment will still be conducted in English unless specified
          otherwise.
        </ModalParagraph>
        <ModalParagraph>
          You must agree to our{' '}
          <Link
            href={theme?.privacyPolicy ?? PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            {...renderLinkTrackingAttributes({
              trackedelementId: TrackedElementId.DETAILS_TERMS_PRIVACY,
              trackedelementAction: TrackedElementAction.CLICK,
            })}
          >
            Privacy Policy
          </Link>
          ,{' '}
          <Link
            href={theme?.termsOfUse ?? TERMS_URL}
            target="_blank"
            rel="noopener noreferrer"
            {...renderLinkTrackingAttributes({
              trackedelementId: TrackedElementId.DETAILS_TERMS_TERMS,
              trackedelementAction: TrackedElementAction.CLICK,
            })}
          >
            Terms of Use
          </Link>{' '}
          and{' '}
          <Link
            href={theme?.collectionPolicyUrl ?? COLLECTION_NOTICE_URL}
            target="_blank"
            rel="noopener noreferrer"
            {...renderLinkTrackingAttributes({
              trackedelementId: TrackedElementId.DETAILS_TERMS_COLLECTION,
              trackedelementAction: TrackedElementAction.CLICK,
            })}
          >
            Collection Notice
          </Link>{' '}
          statements before setting your preferred language.
        </ModalParagraph>
        <Button
          trackingData={{
            event: TrackingDataEvent.CTA_PRIMARY,
            cta: TrackingDataCta.PREFERRED_LANGUAGE_AGREE,
          }}
          onClick={() => onConfirm()}
        >
          I agree
        </Button>
        <CancelButton
          options={{ textOnly: true }}
          trackingData={{
            event: TrackingDataEvent.CTA_SECONDARY,
            cta: TrackingDataCta.PREFERRED_LANGUAGE_CANCEL,
          }}
          onClick={() => onCancel()}
        >
          Cancel
        </CancelButton>
      </StyledModal>
    </StandardModal>
  );
};
